import { cn } from '@/util/cn';
import { Spinner } from '@/components/Spinner/index';
import { ISpinnerProps } from './types';

interface IProps extends ISpinnerProps {
  className?: string,
}

export const SpinnerCenteredWrapper = ({ className, ...props }: IProps) => (
  <div className={cn('flex h-40 w-full justify-center', className)}>
    <Spinner {...props} />
  </div>
);
